import ListTable from './ListTable.component';

export default ListTable;
